import React, { useEffect, useState } from "react";
import Confetti from "react-confetti";
import useWindowSize from "../../hooks/useWindowSize";
import WinnerTrophy from "./WinnerTrophy";
import Button from "../atoms/Buttons";
import "./HotSeatWinnerContent.css";

function Letters({ text, className }) {
  let index = 0;
  return String(text).split(/(\s+)/).map((word, wordIndex) =>
    /\s/.test(word) ? word : (
      <span className="royal-name-word" aria-hidden="true" key={wordIndex}>
        {Array.from(word).map((letter) => (
          <span className={className} key={index} style={{ "--letter": index++ }}>{letter}</span>
        ))}
      </span>
    )
  );
}

export default function HotSeatWinnerContent({ winner, showWinner, onRestart, onConfirm, celebrate = false }) {
  const size = useWindowSize();
  const [reducedMotion, setReducedMotion] = useState(
    () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false
  );
  const [confettiReady, setConfettiReady] = useState(false);
  useEffect(() => {
    const media = window.matchMedia?.("(prefers-reduced-motion: reduce)");
    if (!media) return undefined;
    const change = () => setReducedMotion(media.matches);
    media.addEventListener("change", change);
    return () => media.removeEventListener("change", change);
  }, []);
  // Cada celebración (otro ganador o cambio de celebrate/reducedMotion) vuelve a esperar antes del confeti.
  const celebration = `${celebrate}|${reducedMotion}|${winner.confId}`;
  const [confettiFor, setConfettiFor] = useState(celebration);
  if (celebration !== confettiFor) {
    setConfettiFor(celebration);
    setConfettiReady(false);
  }
  useEffect(() => {
    if (!celebrate || reducedMotion) return undefined;
    const timer = setTimeout(() => setConfettiReady(true), 2800);
    return () => clearTimeout(timer);
  }, [celebrate, reducedMotion, winner.confId]);
  const name = showWinner
    ? [winner.firstName, winner.lastName1, winner.lastName2].filter((value) => value?.trim()).join(" ")
    : "";
  const document = showWinner ? winner.document : null;
  const machine = String(winner.machine ?? winner.confId);
  return (
    <section className="royal-winner" data-testid="royal-winner" data-client={Boolean(name || document)} data-celebrate={celebrate} aria-label="Resultado ganador">
      <div className="royal-neon-corners" aria-hidden="true"><i /><i /><i /><i /></div>
      {confettiReady && !reducedMotion && (
        <Confetti width={size.width} height={size.height} numberOfPieces={100} gravity={0.065} wind={0.015}
          colors={["#ffd25a", "#f5b51b", "#fff0a4", "#c60019", "#f22b35"]}
          opacity={0.9} style={{ zIndex: 1, pointerEvents: "none" }} />
      )}
      <div className="royal-composition">
        <div className="royal-trophy" aria-hidden="true">
          <div className="royal-trophy-aura" />
          <WinnerTrophy active={celebrate} animate={celebrate && !reducedMotion} />
          <div className="royal-orbit" /><div className="royal-orbit second" />
        </div>
        <div className="royal-information">
          <h1 className="royal-heading" aria-label="FELICIDADES">
            <Letters text="FELICIDADES" className="royal-heading-letter" />
          </h1>
          <div className="royal-details">
            <div className="royal-machine">
              <p className="royal-position">POSICIÓN GANADORA</p>
              <div className="royal-machine-number" aria-label={`Número de máquina ${machine}`}
                style={{ "--number-size": `${Math.min(7.9, 76 / Math.max(machine.length, 1))}cqw` }}>
                <Letters text={machine} className="royal-number-letter" />
              </div>
            </div>
            {(name || document) && (
              <div className="royal-client">
                {name && <>
                  <div className="royal-client-label">CLIENTE GANADOR</div>
                  <h2 className="royal-client-name" aria-label={name} data-long={name.length > 35}>
                    <Letters text={name} className="royal-letter" />
                  </h2>
                </>}
                {document && <p className="royal-document">{winner.documentTypeName || "Documento"}: {document}</p>}
              </div>
            )}
          </div>
          <div className="royal-actions">
            <Button variant="outline" onClick={onRestart} tabIndex={onRestart ? undefined : -1}>REINICIAR</Button>
            <Button onClick={onConfirm} tabIndex={onConfirm ? undefined : -1}>CONFIRMAR</Button>
          </div>
        </div>
      </div>
    </section>
  );
}
